import { Model } from "@nozbe/watermelondb";
import { text, date, readonly, relation } from "@nozbe/watermelondb/decorators";
import Customer from "./customer";

export default class Appointment extends Model {
  static table = "appointments";

  @relation("customers", "customer_id") customer?: Customer;
  @date("start_time") startTime?: number;
  @date("end_time") endTime?: number;
  @text("notes") notes?: string;
  @readonly @date("created_at") createdAt?: number;
  @readonly @date("updated_at") updatedAt?: number;
}
